<template>
    <div v-if="show" class="mask">
        <div class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">回复</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="closeForm"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">内容</div>
                        <div class="value"> <textarea  v-model="formData.content" style="height: 200px;"  class="full-width ui-input"></textarea></div>
                    </div>
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">    
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="save">确定</div>   
            </div>
        </div>
    </div>
    

</template>

<script>
    import {saveHtmlReply} from '@/api/api.js';    
    export default {
        name:'HtmlReplyMdoal',
        created() {
        },
        data() {
            return {
                show: false,
                formData:{
                },

            }
        },
        methods:{
            
            showForm(data) {
                this.formData = data;
                this.show = true;
            },
            closeForm() {
                this.show = false;
            },
            save() {
                if (this.formData.content == "") {
                    this.$showToast({msg:"回复内容未填写！"})
                    return false;
                }
                this.$showLoading();
                saveHtmlReply(this.formData).then((res) => {
                    if (res.data.success == true) {
                        this.show = false;
                        this.$emit("confirm");
                        this.$closeLoading(); 

                    }             
                }) 
            }
            
            

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 100px;
    }
    .doc-edit-modal {
        width: 600px;
        height: 400px;
    }
    .edit-area {
       width: 550px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/HtmlReplyModal.vue